import {CompetitionNewsPageRouteMetaDataModel} from "./competition-news-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionNewsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.news,
      path: `news`,
      componentImport: () => import("../components/competition-news-page" /* webpackChunkName: "competition-news-page" */ ),
      metadataType: CompetitionNewsPageRouteMetaDataModel
    });
  }
}